import { render, staticRenderFns } from "./mails_records_v2.vue?vue&type=template&id=9e1dc652&scoped=true&"
import script from "./mails_records_v2.vue?vue&type=script&lang=js&"
export * from "./mails_records_v2.vue?vue&type=script&lang=js&"
import style0 from "./mails_records_v2.vue?vue&type=style&index=0&id=9e1dc652&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e1dc652",
  null
  
)

export default component.exports